import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pagination } from "react-bootstrap";
// import Broken from "../static/broken.png";
import { API_END_POINT } from "../config";
const token = localStorage.getItem("token");

import HasRole from "../../client/hoc/HasRole";

export default class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blogs: [],
      activePage: 1,
      pages: 1,
      q: "",
      loading: false,
      responseMessage: "Loading blogs...",
    };
    // API_END_POINT = 'https://admin.saaditrips.com';
  }
  componentWillMount() {
    this.setState({ loading: true });
    axios.get(`${API_END_POINT}/api/blog/all`).then((response) => {
      console.log("Blogs response", response.data.data);
      let SortedArray = response.data.data;
      SortedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
      this.setState({
        blogs: SortedArray,
        pages: Math.ceil(response.data.length / 10),
        loading: false,
        responseMessage: "No Notification Found",
      });
    });
  }
  deleteBlog(blogId, index) {
    const obj = {
      blogId: blogId,
    };
    if (confirm("Are you sure you want to delete this blog?")) {
      fetch(`${API_END_POINT}/api/blog/delete`, {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          "auth-token": token,
        },
        body: JSON.stringify(obj),
      })
        .then((res) => {
          if (res.status === 200) {
            const blogs = this.state.blogs.slice();
            blogs.splice(index, 1);
            this.setState({ blogs });
            alert("blog Deleted Successfully");
          }
        })
        .catch((err) => console.log(err.message));
    }
  }

  handleSelect(page) {
    axios.get(`/api/area?offset=${(page - 1) * 10}`).then((response) => {
      this.setState({
        areas: response.data.items,
        activePage: page,
      });
    });
  }

  // handleSearch() {
  //   axios.get(`/api/area?q=${this.state.q}`).then((response) => {
  //     this.setState({
  //       areas: response.data.items,
  //       activePage: 1,
  //       pages: Math.ceil(response.data.total / 10),
  //     });
  //   });
  // }
  render() {
    console.log(this.state);
    const { loading, blogs, responseMessage } = this.state;
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row space-1">
            <div className="col-sm-8">
              <h3>Benachrichtigungen</h3>
            </div>
            {/* <div style={{ marginTop: "20px" }} className="col-sm-4">
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  name="search"
                  placeholder="Enter keyword"
                  value={this.state.q}
                  onChange={(event) => this.setState({ q: event.target.value })}
                />
                <span className="input-group-btn">
                  <button
                    type="button"
                    onClick={() => this.handleSearch()}
                    className="btn btn-info search-btn"
                  >
                    Search
                  </button>
                </span>
              </div>
            </div> */}

            <div className="col-sm-2 pull-right">
              <Link to="/notifications/notifications_form">
                <button type="button" className="btn btn-success">
                  Neue Benachrichtigung starten
                </button>
              </Link>
            </div>
          </div>

          <div className="table-responsive" style={{ visibility: "hidden" }}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Nr. #</th>
                  <th>Titel</th>
                  <th>Benachrichtigungstext</th>
                </tr>
              </thead>
              <tbody>
                {this.state.blogs && this.state.blogs.length >= 1 ? (
                  this.state.blogs.map((blog, index) => (
                    <tr key={index}>
                      <td style={{ width: "5px" }}>{index + 1}</td>
                      <td style={{ width: "50px" }}>{blog.title}</td>
                      <td style={{ maxWidth: "400px" }}>
                        <p
                          className="line-clamp mb-0"
                          dangerouslySetInnerHTML={{ __html: blog.blogText }}
                        ></p>
                      </td>
                      {/* <td>
                      <Link to={`/area_resource/${area.id}`}>
                        <button type="button" className="btn btn-info btn-sm">Resource</button>
                      </Link>
                    </td> */}
                      {/* <HasRole requiredRole={['admin']} requiredDepartment={['admin', 'sales']}> */}
                      <td className="text-center">
                        <Link
                          to={`/notifications/edit_notifications/:notificationId`}
                        >
                          <span
                            className="fa fa-edit"
                            aria-hidden="true"
                          ></span>
                        </Link>
                      </td>
                      <td className="text-center">
                        <span
                          className="fa fa-trash"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                          onClick={() => this.deleteBlog(blog._id, index)}
                        ></span>
                      </td>
                      {/* </HasRole> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      {responseMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="text-center">
            <Pagination
              prev
              next
              items={this.state.pages}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            >
              {" "}
            </Pagination>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Notifications.jsx